import { render } from "./UserMenu.root.vue?vue&type=template&id=57110028"
import script from "./UserMenu.root.vue?vue&type=script&lang=js"
export * from "./UserMenu.root.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__